import type { ColumnMetadata } from '../grid/types';

export type CurrencyRateJsMethodOptions = {
  nameApi: string;
  fromCurrency: string;
  toCurrency: string;
  observerIdElement: string;
};

const decodeLegacyJson = (value: string): string => value.replace(/&quot;|&#34;|&#x22;/gi, '"');

export const parseCurrencyRateJsMethodOptions = (
  rawOptions: string | null | undefined
): CurrencyRateJsMethodOptions | null => {
  if (!rawOptions) {
    return null;
  }

  try {
    const options = JSON.parse(
      decodeLegacyJson(rawOptions)
    ) as Partial<CurrencyRateJsMethodOptions>;
    if (
      !options.nameApi?.trim() ||
      !options.fromCurrency?.trim() ||
      !options.toCurrency?.trim() ||
      !options.observerIdElement?.trim()
    ) {
      return null;
    }

    return {
      nameApi: options.nameApi.trim(),
      fromCurrency: options.fromCurrency.trim(),
      toCurrency: options.toCurrency.trim(),
      observerIdElement: options.observerIdElement.trim(),
    };
  } catch {
    return null;
  }
};

export const resolveObserverFieldName = (
  fields: ColumnMetadata[],
  observerIdElement: string
): string | null => {
  const observerField = observerIdElement.replace(/^fld-ni-/i, '').toLowerCase();
  return (
    fields.find((field) => field.dataField?.toLowerCase() === observerField)?.dataField ?? null
  );
};
